module.exports = __webpack_public_path__ + "media/images/icon_fb_gray-8843d58e502f2a6eeb931510b046a1f2.png";